import { SharedUserService } from '@agroone-front/shared'
import { UserRules } from '@agroone/business'
import { User, UserDto, UserPermissions } from '@agroone/entities'
import { registerLocaleData } from '@angular/common'
import localeEs from '@angular/common/locales/es'
import localeFr from '@angular/common/locales/fr'
import localeHu from '@angular/common/locales/hu'
import localeIt from '@angular/common/locales/it'
import localePl from '@angular/common/locales/pl'
import localePt from '@angular/common/locales/pt'
import localeRu from '@angular/common/locales/ru'
import { Injectable, inject } from '@angular/core'
import { environment } from '@front-app-environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class UserService extends SharedUserService {
  private translate = inject(TranslateService)

  override userApiUrl: string = `${environment.apiUrl}${environment.users}`

  private readonly localLanguages: unknown[] = [localeEs, localeFr, localeIt, localePt, localeRu, localePl, localeHu]

  public override init(): Observable<UserDto> {
    this.user.subscribe((user) => {
      if (user) {
        const dateFormat = UserRules.getDateFormatForLanguage(user.language)
        this.currentUserDateFormat = dateFormat
        // SharedUserService types it as DateFormat, but most of these concatenations are not DateFormat values
        this.currentUserDateHourFormat = (dateFormat + ' HH:mm') as any
        this.localLanguages.forEach((language) => registerLocaleData(language))
        this._setLanguage(user.language)
      }
    })
    return this.getCurrentUser()
  }

  private _setLanguage(language: string) {
    localStorage.setItem('userLanguage', language)
    this.translate.setFallbackLang(language)
    this.translate.use(language)
  }

  public hasPermission(user: User, permission: UserPermissions) {
    return user.permissions?.includes(permission)
  }
}
